<template>
	<div>
		<b-overlay :show="isLoading" rounded="sm"> </b-overlay>
		<ClassesTable
			:key="classesTableKey"
			:isLoading="isLoading"
			:tableData="allUserClasses"
			:isSelecting="true"
			:alwaysEnabled="true"
			headerTitle="Classes"
			:headerButtonData="classesHeaderButtonData"
			@viewClicked="openClass"
			@headerButtonClicked="classesButtonClicked"
			@selectionChanged="currentSelection = $event"
		/>
		<ClassesModal
			:show="showClassesModal"
			:exempted-classes="allUserClasses"
			@selectedClasses="addToClasses"
			@close="showClassesModal = false"
		/>
		<QuestionModal
			:show="showQuestionModal"
			:question="modalQuestion"
			@close="showQuestionModal = false"
			@yesClicked="confirmPendingAction"
			@noClicked="showQuestionModal = false"
		/>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
import ClassesTable from '../../ClassesViews/ClassesTable.vue';
import ClassesModal from '../../../../components/Modals/ClassesModal.vue';
import QuestionModal from '../../../../components/Modals/QuestionModal.vue';
import { DashboardChildren } from '../../../../routes/routesNames';
import ClassItemManager from '../../../../models/ClassItem/ClassItemManager';

export default {
	props: {
		userData: null,
		refresh: null,
	},
	data() {
		return {
			isLoading: false,
			allUserClasses: [],
			showClassesModal: false,
			showQuestionModal: false,
			modalQuestion: null,
			pendingClasses: [],
			pendingAction: null,
			currentSelection: [],
			classesTableKey: 0,
		};
	},
	computed: {
		classesHeaderButtonData() {
			return this.currentSelection.length > 0
				? { title: 'Remove From Classes' }
				: { title: 'Add To Class' };
		},
	},
	watch: {
		refresh: {
			handler(val) {
				if (val) {
					return this.getUserClasses();
				}
			},
		},
	},
	methods: {
		...mapActions(['showNotification']),
		getUserClasses() {
			this.isLoading = true;
			ClassItemManager.getUserClasses(this.userData.uid)
				.then((items) => {
					if (items) {
						this.allUserClasses = items;
					}
					this.isLoading = false;
				})
				.catch((error) => {});
		},
		openClass(classData) {
			this.$router.push({
				name: DashboardChildren.classView.name,
				params: {
					classData: classData,
				},
				query: {
					classId: classData.classId,
				},
			});
		},
		classesButtonClicked(items) {
			if (items.length > 0) {
				this.removeFromClasses(items);
			} else {
				this.showClassesModal = true;
			}
		},
		addToClasses(items) {
			this.pendingClasses = items;
			this.pendingAction = 'add';
			this.modalQuestion =
				'Are you sure you want to add this member to these classes? They will bypass any registration or billing.';
			this.showQuestionModal = true;
		},
		removeFromClasses(items) {
			this.pendingClasses = items;
			this.pendingAction = 'remove';
			this.modalQuestion =
				'Are you sure you want to remove this member from these classes? This will cancel their class billing subscription.';
			this.showQuestionModal = true;
		},
		confirmPendingAction() {
			this.showQuestionModal = false;
			this.showClassesModal = false;
			this.isLoading = true;
			const request =
				this.pendingAction == 'add'
					? ClassItemManager.manuallyAddUserToClasses(
							this.pendingClasses,
							this.userData
					  )
					: ClassItemManager.removeUserFromClasses(
							this.pendingClasses,
							this.userData
					  );
			request
				.then(() => {
					this.currentSelection = [];
					this.classesTableKey += 1;
					this.getUserClasses();
				})
				.catch((error) => {
					this.isLoading = false;
					this.showNotification({
						type: 'danger',
						message: error,
					});
				});
		},
	},
	components: { ClassesTable, ClassesModal, QuestionModal },
};
</script>
